import { render, staticRenderFns } from "./CpdNotifications.vue?vue&type=template&id=d3ea0b04&scoped=true"
import script from "./CpdNotifications.vue?vue&type=script&lang=js"
export * from "./CpdNotifications.vue?vue&type=script&lang=js"
import style0 from "./CpdNotifications.vue?vue&type=style&index=0&id=d3ea0b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ea0b04",
  null
  
)

export default component.exports